export const WIDGET_TYPE = Object.freeze({
  VIEW: 500,
  BUTTON: 501,
  CHECKBOX: 502,
  SWITCH: 503,
  DROPDOWN_ITEM: 504,
})
export const PERMISSIONS = Object.freeze({
  VIEW_DASHBOARD: 'view_dashboard',
  VIEW_TENANTS: 'view_tenants',
  EDIT_TENANT_DETAILS: 'edit_tenant_details',
  EDIT_TENANT_ADMIN_DETAILS: 'edit_tenant_admin_details',
  UPDATE_TENANT_ADMIN_ACCESS: 'update_tenant_admin_access',
  ADD_TENANT_ADMIN: 'add_tenant_admin',
  ADD_TENANT: 'add_tenant',
  VIEW_HAULERS: 'view_haulers',
  EDIT_HAULER_DETAILS: 'edit_hauler_details',
  EDIT_HAULER_ADMIN_DETAILS: 'edit_hauler_admin_details',
  UPDATE_HAULER_ADMIN_ACCESS: 'update_hauler_admin_access',
  ADD_HAULER_ADMIN: 'add_hauler_admin',
  REVIEW_HAULER: 'review_hauler',
  ADD_HAULER: 'add_hauler',
  VIEW_VENDORS: 'view_vendors',
  EDIT_VENDOR_DETAILS: 'edit_vendor_details',
  REVIEW_VENDOR: 'review_vendor',
  ADD_VENDOR: 'add_vendor',
  VIEW_PRODUCTS: 'view_products',
  EDIT_PRODUCT: 'edit_product',
  VIEW_MASTER_PRODUCTS: 'view_master_products',
  EDIT_MASTER_PRODUCT: 'edit_master_product',
  EDIT_MASTER_PRODUCT_MAPPING: 'edit_master_product_mapping',
  ADD_MASTER_PRODUCT: 'add_master_product',
  VIEW_CUSTOMERS: 'view_customers',
  EDIT_CUSTOMER_DETAILS: 'edit_customer_details',
  REVIEW_CUSTOMER: 'review_customer',
  ADD_CUSTOMER: 'add_customer',
  VIEW_PLANTS: 'view_plants',
  EDIT_PLANT_DETAILS: 'edit_plant_details',
  REVIEW_PLANT: 'review_plant',
  ADD_PLANT: 'add_plant',
  VIEW_USERS: 'view_users',
  ADD_USER: 'add_user',
  EDIT_USER: 'edit_user',
  UPDATE_USER_STATUS: 'update_user_status',
  VIEW_ROLES: 'view_roles',
  ADD_ROLE: 'add_role',
  EDIT_ROLE: 'edit_role',
  DELETE_ROLE: 'delete_role',
  VIEW_MASTER_ROLES: 'view_master_roles',
  EDIT_MASTER_ROLE: 'edit_master_role',
  ADD_MASTER_ROLE: 'add_master_role',
  ROLE_RECOVERY: 'role_recovery',
})
